import React, { useEffect } from 'react'
import { footPrintColumns } from 'src/core/table-columns'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { getMyFootPrintList, myFootprintSelector } from 'src/features'
import { CustomCard, CustomTable, FootPrintListHeader } from 'src/components'

const FootPrintList: React.FC = () => {
  const dispatch = useAppDispatch()
  const { list, loading } = useAppSelector(myFootprintSelector)

  useEffect(() => { dispatch(getMyFootPrintList()) }, [dispatch])

  return <CustomCard loading={loading}>
    <FootPrintListHeader />
    <CustomTable
      columns={footPrintColumns}
      dataSource={list}
    />
  </CustomCard>
}

export default FootPrintList
